import { useEffect } from 'react';
import { getAdminDetails, getUserDetails } from '../../api/actions';
import { useAuth, useUserDetails } from '../../zustand';
import { useQuery } from '@tanstack/react-query';
import { getCustomerInfo } from '../../pages/ProtectedPages/Customers/actions';
import { capitalizeFirstLetter } from '../../helpers/functions';

export const useGetUserDetails = () => {
  const { userId, token, role } = useAuth((s) => s);
  const { setUserDetails } = useUserDetails((s) => s);
  const resp = useQuery({
    queryKey: ['getUserDetails'],
    queryFn: () =>
      role === 'customer'
        ? getCustomerInfo({ id: userId })
        : role === 'admin'
          ? getAdminDetails({ id: userId })
          : getUserDetails({ id: userId }),
    select: (data) => data?.data?.data,
    enabled: Boolean(token) && Boolean(userId),
  });
  const { status, data, isRefetching, isFetched } = resp;

  useEffect(() => {
    if (
      status === 'success' &&
      data &&
      isRefetching === false &&
      isFetched === true
    ) {
      setUserDetails(data);
      document.title = capitalizeFirstLetter(data?.company) || 'Rorotel';
    }
  }, [data, isFetched, isRefetching, setUserDetails, status]);

  return resp;
};
